import { render } from "./CustomerApplications.vue?vue&type=template&id=4f35084c"
import script from "./customer_applications.js?vue&type=script&lang=js&external"
export * from "./customer_applications.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__